module.exports = __webpack_public_path__ + "static/media/sushant-palakurthi-rao.a7c55e75.jpeg";